import React, { useCallback, useEffect, useRef, useState } from "react";
import { Btn } from "../../../AbstractElements";
import ReusableDropdown from "../../../Component/BasicComponents/Dropdowns/RouteDropdown";
import DualListBox from "../../../Component/BasicComponents/DualListBox";
import { handleMedia } from "../repository/EdetailingRepository";
import NewDualList from "../../ProductCatalogue/BrandCampaignStep/Reubale_DualList/NewDualList";
import {
  useAddPlaylist,
  usePresentationData,
  usePresentationDrowDown,
  useUpdatePlaylist,
} from "../hooks/useEdetailing";
import { useGetOrgUnitsData } from "../../Configuration/Grade Master/hooks/useGradeMaster";
import { showToast } from "../../../utils/toastUtils";

interface EdPlaylistModalContentProps {
  handleClose: () => void;
  chechStatusSubmitAndUpdate: string;
  playlistTypeData: any;
  outletData: any;
  presentationTypeData: any;
  selectedRow?: any;
}

const EdPlaylistModalContent: React.FC<EdPlaylistModalContentProps> = ({
  handleClose,
  chechStatusSubmitAndUpdate,
  playlistTypeData,
  outletData,
  presentationTypeData,
  selectedRow,
}) => {
  const blockObserverRef = useRef(false);
  const [search, setSearch] = useState("");
  const [rightListData, setRightListData] = useState<any[]>([]);
  const [initalLeftSideData, setInitalLeftSideData] = useState<any[]>([]);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [hasMoreData, setHasMoreData] = useState(true);
  const [length, setLength] = useState(10);
  const [APISearch, SetAPISearch] = useState("");

  useEffect(() => {
    const debounceTimer = setTimeout(() => {
      if (search.trim() || search === "") {
        SetAPISearch(search);
      }
    }, 500);
    return () => clearTimeout(debounceTimer);
  }, [search]);

  const { data: presentations, isSuccess } = usePresentationDrowDown({
    enable: true,
    params: {
      page: 1,
      limit: length,
      search: APISearch,
    },
  });

  const { mutate: addPlaylist } = useAddPlaylist();
  const { mutate: updatePlaylist } = useUpdatePlaylist();
  const { data: getOrgunitData } = useGetOrgUnitsData({ enable: true });
  const orgUnitIdsss = Object.entries(getOrgunitData?.data || {}).map(
    ([key, value]) => ({
      id: key,
      label: value,
    })
  );

  const [formData, setFormData] = useState({
    PlaylistId: "",
    PlaylistName: "",
    PlaylistVersionId: "",
    PlaylistTypeId: "",
    OrgunitId: "",
    Presentations: [],
    OutletTags: [],
    PlaylistMedia: "",
  });
  const BASE_URL = "https://tspc-development.truesales.in/media?id=";

  useEffect(() => {
    if (presentations?.formatedData) {
      const timer = setTimeout(() => {
        blockObserverRef.current = false;
      }, 1000);

      setInitalLeftSideData((prev) => {
        //Step 1 fresh search
        if (length == 10) {
          const rightIds = new Set(rightListData.map((item) => item.id));
          return presentations?.formatedData.filter(
            (item: any) => !rightIds.has(item.id)
          );
        }
        const combineData = [...prev, ...presentations?.formatedData];

        // If the same key appears again, it overwrites the old value with the new one.
        // Converts the Map’s values into a normal array.
        const uniqueByID = Array.from(
          new Map(combineData?.map((item) => [item.id, item])).values()
        );

        const rightIds = new Set(rightListData.map((item) => item.id));
        return Array.from(uniqueByID).filter((item) => !rightIds.has(item.id));
      });
      setIsLoadingMore(false);
      return () => clearTimeout(timer);
    }
  }, [isSuccess, presentations?.formatedData]);

  const handleLeftSideitem = (item: any) => {
    setInitalLeftSideData(initalLeftSideData.filter((it) => it.id !== item.id));
    setRightListData((prev) => [...prev, item]);
  };

  const handleRightSideitem = (item: any) => {
    setRightListData(rightListData.filter((it: any) => it.id !== item.id));
    setInitalLeftSideData((prev: any) => [...prev, item]);
  };

  const handleLeftbtn = () => {
    const newRightList = [...rightListData, ...initalLeftSideData];
    setRightListData(newRightList);
    setInitalLeftSideData([]);
  };

  const handleRightbtn = () => {
    const newRightSodeList = [...initalLeftSideData, ...rightListData];
    setInitalLeftSideData(newRightSodeList);
    setRightListData([]);
  };

  const handleSearchInputLeft = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputSearch = e.target.value;

    setSearch(inputSearch);
    blockObserverRef.current = true;
    setInitalLeftSideData([]); // Clear previous data for fresh search
  };

  const onReachEnd = useCallback(() => {
    if (!isLoadingMore && hasMoreData) {
      setIsLoadingMore(true);
      setTimeout(() => {
        setLength((prev: any) => {
          const newLength = prev + 10;
          return newLength;
        });
      }, 500);
    }
  }, [isLoadingMore, hasMoreData]);

  useEffect(() => {
    if (selectedRow) {
      setFormData({
        PlaylistId: selectedRow?.id || "",
        PlaylistName: selectedRow?.playlistname || "",
        PlaylistVersionId: selectedRow?.playlistversionid || "",
        PlaylistTypeId: selectedRow?.playlisttypeid || "",
        OrgunitId: selectedRow?.orgunit || "",
        Presentations: selectedRow?.presentation || [],
        OutletTags: selectedRow?.OutletTags || [],
        PlaylistMedia: selectedRow?.PlaylistMedia || "",
      });

      const PresentationId = selectedRow?.PresentationId || [];
      const presentation = selectedRow?.presentation || [];
      const Formated_Presentations_Data = PresentationId.map(
        (id: any, index: number) => ({
          id: id,
          label: presentation[index],
        })
      );

      setRightListData((prev) => {
        const newItems = Formated_Presentations_Data.filter(
          (newItem: any) => !prev.some((item) => item.id === newItem.id)
        );
        return [...prev, ...newItems]; // <- flat merge
      });
    }
  }, [selectedRow]);

  const handleInputChange = (e: any) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      try {
        const mediaId = await handleMedia(file);
        console.log("mediaiii", mediaId);

        setFormData((prev) => ({ ...prev, PlaylistMedia: mediaId }));
        console.log("Uploaded Media ID:", mediaId);
      } catch (error) {
        console.error("Media upload failed:", error);
      }
    }
  };

  const handleSubmit = (e: React.FormEvent, formData: any) => {
    e.preventDefault();

    if (chechStatusSubmitAndUpdate === "Submit") {
      if (rightListData.length === 0) {
        showToast.warning("Please Select Presentation");
        return;
      } else if (!formData.PlaylistName) {
        showToast.warning("Please Fill the Playlist Name");
        return;
      } else if (!formData.PlaylistTypeId) {
        showToast.warning("Please select the Playlist Type Name");
        return;
      } else if (!formData.OrgunitId) {
        showToast.warning("Please select the Org Unit");
        return;
      }

      const Presentations: string[] = Array.isArray(rightListData)
        ? rightListData.map((item: any) => item.id)
        : [];

      const ReqBody = {
        PlaylistName: formData.PlaylistName,
        PlaylistTypeId: formData.PlaylistTypeId,
        OrgunitId: formData.OrgunitId,
        Presentations: Presentations,
        PlaylistVersionId: Number(formData.PlaylistVersionId),
        OutletTags: formData.OutletTags,
        PlaylistMedia: formData.PlaylistMedia,
      };
      addPlaylist(ReqBody);
    }

    if (chechStatusSubmitAndUpdate === "Update") {
      if (rightListData.length === 0) {
        showToast.warning("Please Select Presentation");
        return;
      } else if (!formData.PlaylistName) {
        showToast.warning("Please Fill the Playlist Name");
        return;
      } else if (!formData.PlaylistTypeId) {
        showToast.warning("Please select the Playlist Type Name");
        return;
      } else if (!formData.OrgunitId) {
        showToast.warning("Please select the Org Unit");
        return;
      }
      const Presentations: string[] = Array.isArray(rightListData)
        ? rightListData.map((item: any) => item.id)
        : [];

      const ReqBody = {
        PlaylistId: Number(formData.PlaylistId),
        PlaylistName: formData.PlaylistName,
        PlaylistTypeId: formData.PlaylistTypeId,
        OrgunitId: formData.OrgunitId,
        Presentations: Presentations,
        PlaylistVersionId: Number(formData.PlaylistVersionId),
        OutletTags: formData.OutletTags,
        PlaylistMedia: formData.PlaylistMedia,
      };

      console.log("ReqBodyUpdate", ReqBody);
      updatePlaylist(ReqBody);
    }
    handleClose();
    setFormData({
      PlaylistId: "",
      PlaylistName: "",
      PlaylistVersionId: "",
      PlaylistTypeId: "",
      OrgunitId: "",
      Presentations: [],
      OutletTags: [],
      PlaylistMedia: "",
    });
  };

  // console.log('Type==========>',typeof(formData.PlaylistTypeId));

  return (
    <form onSubmit={(e) => handleSubmit(e, formData)}>
      <div className="row mb-3">
        <div className="col-md-4 mt-2">
          <label style={{ fontWeight: "500" }}>
            Playlist Name <span style={{ color: "red" }}>*</span>
          </label>
          <input
            type="text"
            name="PlaylistName"
            className="form-control"
            placeholder="Enter playlist name"
            value={formData.PlaylistName}
            onChange={handleInputChange}
            style={{
              border: "2px solid #EDEDED",
              borderRadius: "8px",
              padding: "12px",
              fontSize: "14px",
              width: "100%",
            }}
          />
        </div>

        <div className="col-md-4" style={{ zIndex: 8 }}>
          <ReusableDropdown
            options={playlistTypeData?.map((b: any) => ({
              id: b.EdPlaylistTypeId,
              label: b.PlaylistTypeName,
            }))}
            DropdownHeading="Type"
            asterisk={true}
            onChange={(selected: any) => {
              setFormData({ ...formData, PlaylistTypeId: selected });
            }}
            value={formData.PlaylistTypeId}
          />
        </div>

        <div className="col-md-4">
          <ReusableDropdown
            options={orgUnitIdsss?.map((b: any) => ({
              id: b.id,
              label: b.label,
            }))}
            DropdownHeading="Org Unit"
            asterisk={true}
            onChange={(selected: any) =>
              setFormData({ ...formData, OrgunitId: selected })
            }
            value={formData.OrgunitId}
          />
        </div>
      </div>

      <div className="row mb-4 mt-2">
        <div className="col-md-6">
          <p
            style={{
              color: "#3D3D47",
              marginBottom: "14px",
              fontWeight: "500",
            }}
          >
            Presentations <span style={{ color: "red" }}>*</span>
          </p>
          <NewDualList
            LeftListOptionData={initalLeftSideData || []}
            RightListOptionData={rightListData}
            leftSideitem={handleLeftSideitem}
            rightSideitem={handleRightSideitem}
            handleLeftbtn={handleLeftbtn}
            handleRightbtn={handleRightbtn}
            handleSearchInputLeft={handleSearchInputLeft}
            // handleSearchInputRight={handleSearchInputRight}
            onReachEnd={onReachEnd}
            blockObserverRef={blockObserverRef}
          />
        </div>

        <div className="col-md-6">
          {formData.PlaylistTypeId == "1" && (
            <DualListBox
              styleLeftContaianer={{ height: "200px" }}
              styleRightContaianer={{ height: "200px" }}
              listStyleLeft={{ height: "150px" }}
              listStyleRight={{ height: "150px" }}
              DualListLabel="Outlet Tags"
              leftOptions={outletData?.map((b: any) => ({
                id: b.id,
                label: b.label,
              }))}
              onSelectionChange={(selected: any) => {
                setFormData({
                  ...formData,
                  ["OutletTags"]: selected?.map((item: any) => `${item?.id}`),
                });
              }}
              value={formData.OutletTags}
            />
          )}
        </div>
      </div>

      <div className="row mb-3">
        <div className="col-md-6">
          <label style={{ fontWeight: "500" }}>
            Playlist VersionId <span style={{ color: "red" }}>*</span>
          </label>
          <input
            type="text"
            name="PlaylistVersionId"
            className="form-control"
            placeholder="Enter playlist versionId"
            value={formData.PlaylistVersionId}
            onChange={handleInputChange}
            style={{
              border: "2px solid #EDEDED",
              borderRadius: "8px",
              padding: "13px",
              fontSize: "14px",
              width: "100%",
            }}
          />
        </div>
        <div className="col-md-6">
          <label style={{ fontWeight: "500" }}>Media</label>
          <input
            type="file"
            className="form-control"
            accept="image/*"
            onChange={handleFileChange}
            style={{
              border: "2px solid #EDEDED",
              borderRadius: "8px",
              padding: "13px",
              fontSize: "14px",
              width: "100%",
            }}
          />
        </div>
      </div>

      {formData.PlaylistMedia && (
        <div className="row mb-3">
          <div className="col-md-6" style={{ marginBottom: "10px" }}>
            <label style={{ fontWeight: "500", display: "block" }}>
              Uploaded Media
            </label>

            <img
              src={
                formData.PlaylistMedia
                  ? `${BASE_URL}${formData.PlaylistMedia}`
                  : "https://via.placeholder.com/100?text=No+Image"
              }
              alt={formData.PlaylistMedia ? "Uploaded Media" : "Dummy Image"}
              style={{
                width: "100px",
                height: "100px",
                borderRadius: "8px",
                marginTop: "8px",
              }}
            />
          </div>
        </div>
      )}

      {/* Buttons */}
      <div className="d-flex justify-content-start mt-3 gap-2">
        <Btn
          style={{ backgroundColor: "#43B9B2", color: "white" }}
          type="submit"
        >
          {chechStatusSubmitAndUpdate === "Submit" ? "Submit" : "Update"}
        </Btn>
        <Btn
          style={{
            backgroundColor: "#F9FAFC",
            color: "#000",
            border: "1px solid #E0E0E0",
          }}
          type="button"
          onClick={handleClose}
        >
          Cancel
        </Btn>
      </div>
    </form>
  );
};

export default EdPlaylistModalContent;
